module.exports = "<app-header></app-header>\r\n<div>\r\n  <router-outlet></router-outlet>\r\n</div>\r\n<div class=\"bg-white\">\r\n  <app-footer></app-footer>\r\n</div>\r\n<div class=\"d-none d-md-block\">\r\n  <div class=\"scroll-top \">\r\n    <i class=\"fas fa-long-arrow-alt-up\"></i>\r\n  </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/frontend/frontend.component.html
// module id = ./src/app/frontend/frontend.component.html
// module chunks = frontend.module